export const mesesPlanAnual = {
    diagnostico: 'Diagnóstico',
    junio: 'Junio',
    julio: 'Julio',
    agosto: 'Agosto',
    septiembre: 'Septiembre',
    octubre: 'Octubre',
    diciembre: 'Diciembre',
};

export const mesesPlanIntensivo = {
    diagnostico: 'Diagnóstico',
    septiembre: 'Septiembre',
    octubre: 'Octubre',
    diciembre: 'Diciembre',
};



// WEBPACK FOOTER //
// ./src/recursos/mesesEnsayo.ts